// The mdast-util-to-markdown, mdast-util-mdx-jsx and @types/mdast ranges in
// package.json are aligned with the versions @mdxeditor/editor declares, so
// npm dedupes them to the editor's own copies. When updating
// @mdxeditor/editor, re-align those ranges with the new declarations.
import { toMarkdown } from 'mdast-util-to-markdown'
import { mdxJsxToMarkdown } from 'mdast-util-mdx-jsx'
import type { Paragraph, PhrasingContent, Root } from 'mdast'

// Converts plain text into markdown that displays exactly like the original
// text: markdown control characters are escaped, single newlines become
// hard breaks and blank lines separate paragraphs. Serialization is
// delegated to mdast-util-to-markdown with the same extension setup
// MDXEditor uses when saving, so the escaping rules always match what the
// editor itself produces.
export default function plainTextToMarkdown(text: string): string {
  const normalized = text.replace(/\r\n?/g, '\n').replace(/\s+$/, '')
  if (!normalized) return ''

  const paragraphs: Paragraph[] = normalized
    .split(/\n{2,}/)
    .filter((block) => block !== '')
    .map((block) => {
      const children: PhrasingContent[] = []
      block.split('\n').forEach((line, index) => {
        if (index > 0) children.push({ type: 'break' })
        if (line) children.push({ type: 'text', value: line })
      })
      return { type: 'paragraph', children }
    })

  const root: Root = { type: 'root', children: paragraphs }
  return toMarkdown(root, { extensions: [mdxJsxToMarkdown()] }).trimEnd()
}
